import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent } from '@ecom/ui/card';

export const Route = createFileRoute('/(app)/orders/')({
  component: OrdersPage,
});

function OrdersPage() {
  return (
    <div className="p-6 space-y-4">
      <h1 className="text-2xl font-bold">Orders</h1>
      <Card>
        <CardContent className="p-8 text-center text-muted-foreground">
          Order listing — sync runs every 15 minutes once a shop is connected.
        </CardContent>
      </Card>
    </div>
  );
}
